import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Offer} from '../../../../../core/models/offer/offer.model';
import {NextOffersSectionStateService} from '../../../../../core/services/impl/section-services/next-offers/next-offers-section-state.service';
import {Subscription} from 'rxjs/Rx';
import {
  InsuranceCompanyTableOffers,
  OffersTableColumnConfig,
  OffersTableService, OffersTableSortState
} from '../../../../../core/services/impl/offers-table.service';
import {FiltersService} from '../../../../services/filters.service';

@Component({
  selector: 'app-offers-table',
  templateUrl: './offers-table.component.html',
  styleUrls: []
})
export class OffersTableComponent implements OnInit, OnDestroy {

  @Input() offers: Offer[];

  columns: OffersTableColumnConfig[];
  offersData: InsuranceCompanyTableOffers[];

  private subscriptions: Subscription[] = [];

  constructor(public offersTableService: OffersTableService,
              private filtersService: FiltersService,
              private offersSectionStateService: NextOffersSectionStateService) { }

  ngOnInit() {
    this.columns = this.offersTableService.getColumns();
    this.handleEvents();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onSortUpdate(sortState: OffersTableSortState): void {
    this.offersTableService.updateSort(sortState);
    this.offersData = this.offersTableService.sortTableData(this.offersData);
  }

  private handleEvents(): void {
    this.subscriptions.push(
        this.offersSectionStateService.offersUpdate$.subscribe(() => {
          if (this.offersSectionStateService.isTableView) {
            this.updateTable();
          }
      })
    );
    this.subscriptions.push(
        this.offersSectionStateService.offersViewChange$.subscribe(() => {
          if (this.offersSectionStateService.isTableView) {
            this.updateTable();
          }
        })
    );
    this.subscriptions.push(
        this.filtersService.filtersChangeEvent.subscribe(() => {
          setTimeout(() => {
            if (this.offersSectionStateService.isTableView) {
              this.updateTable();
            }
          }, 0);
        })
    );
  }

  private updateTable(): void {
    this.offersData = this.offersTableService.createTableOffersData(this.offers);
  }

}
